import React, { useContext } from "react";
import { RicosViewerContext } from "./../../ricos-context/index.js";
import { GALLERY_TYPE } from "../types.js";
import { GalleryViewer } from "./gallery-viewer.js";
const Gallery = ({ node, nodeIndex, NodeViewContainer }) => {
  const { relValue, anchorTarget, config, seoMode, helpers, baseUrl } = useContext(RicosViewerContext);
  return /* @__PURE__ */ React.createElement(NodeViewContainer, { node, nodeIndex }, /* @__PURE__ */ React.createElement(
    GalleryViewer,
    {
      componentData: node.galleryData || {},
      nodeId: node.id,
      settings: config[GALLERY_TYPE],
      relValue,
      anchorTarget,
      seoMode,
      helpers,
      baseUrl
    }
  ));
};
const GalleryRenderer = ({ node, ...props }) => {
  return /* @__PURE__ */ React.createElement(Gallery, { key: node.id, node, ...props });
};
var gallery_default = GalleryRenderer;
export {
  gallery_default as default
};
//# sourceMappingURL=gallery.js.map
